import { Action } from '@ngrx/store';

export function ShowLoader() {
  return function (actionClass: new (...args: any[]) => Action) {
    Object.defineProperty(actionClass.prototype, 'showLoader', {
      value: true,
    });
  };
}
